import React from "react";
import { NavLink } from "react-router-dom";
import './shiftschedule.scss';
import { useQuery } from "@tanstack/react-query";
import Departments from "../../components/shift-schedule/Department";
import Loader from "../../components/loader/Loader";
import axiosaim from "../../api/axiosaim";
import ShiftScheduleOutlet from "../../components/shift-schedule/ShiftScheduleOutlet";

const Shiftschedule = () => {    
    const aimtoken = sessionStorage.getItem('aimtoken') || '';
    const departmentslug = sessionStorage.getItem('departmentslug') || '';
    const uname = sessionStorage.getItem('uname'); 

    const { data: role } = useQuery({
        queryKey: ['userrole']
    });

    const { data: manageddepartments, isLoading: isLoadingDepartments } = useQuery({
        queryKey: ['managedAIMDepartments', uname],
        queryFn: async () => {
            const res = await axiosaim.get(`getmanageddepartments`, {
                headers: { 'X-Aim-Token': aimtoken }
            });
            return res.data;
        },
        enabled: !!uname && !!aimtoken,
        retry: 1
    });


    return (
        <div className="shift-schedules">
            <div className="page-header">
                <div className='title'>
                    <h1>Shift Schedules</h1>
                    <ul className='breadcrumbs'>
                        <li>
                            <NavLink to='/dtr'>DTR</NavLink>
                        </li>
                        <li>
                            <>{
                                (role === 'admin')
                                    ? (<NavLink to='/dtr/shifts'>Shifts</NavLink>)
                                    : (<span>Shifts</span>)
                            }</>
                        </li>
                        <li>
                            <span>Schedules</span>
                        </li>
                    </ul>
                </div>
            </div>

            { isLoadingDepartments 
                ? (
                    <div className="columns">
                        <Loader />
                    </div>
                ) 
                : manageddepartments?.length > 1
                    ? (
                        <Departments departments={manageddepartments} loading={isLoadingDepartments} />
                    ) : (
                        <ShiftScheduleOutlet departmentslug={departmentslug} />
                    )
            }

        </div>
    )
}

export default Shiftschedule;